export type Times = {
	seconds: number;
	minutes: number;
	hours: number;
	days: number;
};

export const calculateReadableTimes = (totalSecondsLeft: number): Times => {
	const secondsPerMinute = 60;
	const secondsPerHour = 60 * secondsPerMinute;
	const secondsPerDay = 24 * secondsPerHour;

	return {
		seconds: Math.floor(totalSecondsLeft % secondsPerMinute),
		minutes: Math.floor((totalSecondsLeft / secondsPerMinute) % secondsPerMinute),
		hours: Math.floor((totalSecondsLeft / secondsPerHour) % 24),
		days: Math.floor(totalSecondsLeft / secondsPerDay),
	};
};

export const calculateSecondsDifferenceFromNow = (DateTime: Date): number => {
	return Math.floor((DateTime.getTime() - new Date().getTime()) / 1000);
};

export const isStringADate = (date?: string): boolean => {
	try {
		if (date) {
			return !isNaN(new Date(date).getTime());
		}
		return false;
	} catch {
		return false;
	}
};

export const isToday = (date: Date): boolean => {
	const today = new Date();
	return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};

export const formatCountdownTimes = (times: Times): string => {
	const hoursFromDays = times.days * 24;
	const hours = times.hours + hoursFromDays;
	return `${leftPad(hours)}:${leftPad(times.minutes)}:${leftPad(times.seconds)}`;
};

const leftPad = (number: number) => number.toString().padStart(2, '0');
